const COTIS = (state, cotizaciones) => {
    state.cotizaciones = cotizaciones;
};

const PARA_ORDEN_COMPRA = (state, para_orden_compra) => {
    state.cotizaciones = para_orden_compra;
};

export default {
    COTIS,
    PARA_ORDEN_COMPRA,
};